import { AbstractDTO } from '../models/dto/abstract';

/**
 * Created by dimah on 31/12/17.
 */
export class InlineEditorConfig extends AbstractDTO {
    hideButtons: boolean;
    cancelOnEscape: boolean;
    saveOnEnter: boolean;
    editOnClick: boolean;
    placeholder: string;
    empty: string;

    constructor(attributes?: object) {
        attributes = attributes || {};
        super(attributes);

        this.hideButtons = Boolean(attributes['hideButtons']) || true;
        this.cancelOnEscape = Boolean(attributes['cancelOnEscape']) || true;
        this.saveOnEnter = Boolean(attributes['saveOnEnter']) || false;
        this.editOnClick = Boolean(attributes['editOnClick']) || false;
        this.placeholder = attributes['placeholder'] || "";
        this.empty = attributes['empty'] || "";
    }

}